// src/pages/Dashboard/Admin/DepensesRecettesDashboard/components/AccountingDrawer.jsx

import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { FaTimes } from "react-icons/fa";

export default function AccountingDrawer({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  size = "xl",
}) {
  useEffect(() => {
    if (!open) return undefined;

    const root = document.documentElement;
    const previousOverflow = root.style.overflow;
    root.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      root.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  const sizes = {
    md: "max-w-xl",
    lg: "max-w-2xl",
    xl: "max-w-4xl",
    "2xl": "max-w-6xl",
  };

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[9999]">
      <button
        type="button"
        className="absolute inset-0 cursor-default bg-slate-950/60 backdrop-blur-sm"
        onClick={onClose}
        aria-label="Fermer"
      />

      <aside
        className={[
          "absolute right-0 top-0 flex h-full w-full flex-col overflow-hidden bg-white shadow-2xl dark:bg-slate-950",
          sizes[size] || sizes.xl,
        ].join(" ")}
        role="dialog"
        aria-modal="true"
      >
        <header className="shrink-0 border-b border-slate-200 bg-white px-5 py-4 dark:border-slate-800 dark:bg-slate-950 sm:px-6">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-indigo-500 dark:text-indigo-300">
                Dépenses & recettes
              </p>

              <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
                {title}
              </h2>

              {subtitle ? (
                <p className="mt-1 text-sm leading-6 text-slate-500 dark:text-slate-400">
                  {subtitle}
                </p>
              ) : null}
            </div>

            <button
              type="button"
              onClick={onClose}
              className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-slate-100 text-slate-600 transition hover:bg-slate-200 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
              aria-label="Fermer le panneau"
            >
              <FaTimes />
            </button>
          </div>
        </header>

        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-5 dark:bg-slate-950 sm:px-6">
          {children}
        </div>

        {footer ? (
          <footer className="shrink-0 border-t border-slate-200 bg-white px-5 py-4 dark:border-slate-800 dark:bg-slate-950 sm:px-6">
            {footer}
          </footer>
        ) : null}
      </aside>
    </div>,
    document.body
  );
}